import Dexie from 'dexie';
import { OfflineSyncStatus } from './offlineQueueUtils';

export default class OfflineQueueDB {
  constructor() {
    this.db = new Dexie('OfflineQueueDB');
    this.db.version(1).stores({
      queue: '++id,key,status,entityType'
    });
  }

  async addItem({ key, url, method, payload, entityType }) {
      return await this.db.queue.add({
        key,
        url,
        method,
        payload,
        retryCount: 0,
        createdAt: new Date().toISOString(),       
        entityType,
        status: OfflineSyncStatus.PENDING
      });    
  }
  
  async updateItem(id, {payload, retryCount, status, error, lastReqTime}) {

      return await this.db.queue.update(id, {
      payload,
      retryCount,
      status,
      error,
      lastReqTime,
      createdAt: new Date().toISOString(),
    });
      }

  async getItem(id) {
  return await this.db.queue.get(id);
  }

  async getAllItems() {
    return await this.db.queue.toArray();
  }

  async removeItem(id) {
    return await this.db.queue.delete(id);
  }

  async incrementRetryCount(id) {
    const item = await this.db.queue.get(id);
    if (item) {
      await this.db.queue.update(id, { retryCount: item.retryCount + 1 });
    }
  }

  async clearQueue() {
    await this.db.queue.clear();
  }

  async getByKey(key) {  
    return await this.db.queue.where('key').equals(key).first();
  }

  async getAllItemsByKey(key) {  
    return await this.db.queue.where('key').equals(key).toArray();
  }

  async getByTaskId(taskId) {
    return await this.db.queue
      .where('taskId')
      .equals(taskId)
      .toArray();   // return all records for this task
  }

}